import { readFiles, readFilesAsDataURLs } from '@/utils/files'

export default {
    bind: function (target, binding) {
        if (!binding.value) {
            return
        }

        let reader = readFiles

        switch (binding.arg) {
            case 'data-url':
                reader = readFilesAsDataURLs
            case 'raw':
                reader = f => f
        }

        target.addEventListener('drop', async e => {
            e.preventDefault()

            binding.value(await reader(e.dataTransfer.files))

            target.classList.remove('dragging')
        })

        target.addEventListener('dragover', e => e.preventDefault())
        target.addEventListener('dragenter', () => target.classList.add('dragging'))
        target.addEventListener('dragleave', e => {
            const rect = target.getBoundingClientRect()
            if (e.clientX < rect.left || e.clientX > rect.right || e.clientY > rect.bottom || e.clientY < rect.top) {
                target.classList.remove('dragging')
            }
        })
    },
}
